export const furnitureCatalog = [
  {
    id: 1,
    name: 'Organik Kenar Yemek Masası',
    category: 'Masa',
    image: 'https://public.readdy.ai/ai/img_res/283edd2f2b926f891f7560a6d6967bb6.jpg',
    description: 'Doğal ahşabın benzersiz dokusunu yansıtan, el işçiliği ile üretilmiş organik kenar yemek masası. Her biri eşsiz bir sanat eseridir.',
    materials: ['Masif Ceviz Ahşap', 'Doğal Kenar', 'Çevre Dostu Vernik'],
    dimensions: '200cm x 100cm x 75cm'
  },
  {
    id: 2,
    name: 'Modern Keten Koltuk',
    category: 'Oturma',
    image: 'https://readdy.ai/api/search-image?query=modern%20minimalist%20armchair%20natural%20linen%20fabric%20wooden%20legs%20contemporary%20design%20clean%20white%20background%20studio%20shot%20elegant%20seating%20furniture&width=500&height=600&seq=catalog-2&orientation=portrait',
    description: 'Doğal keten kumaş ve meşe ahşap ayaklarla tasarlanmış, konfor ve estetiği bir araya getiren modern koltuk.',
    materials: ['Doğal Keten Kumaş', 'Meşe Ahşap', 'Yüksek Yoğunluklu Sünger'],
    dimensions: '85cm x 90cm x 95cm'
  },
  {
    id: 3,
    name: 'Akışkan Form Raf Sistemi',
    category: 'Depolama',
    image: 'https://readdy.ai/api/search-image?query=sculptural%20flowing%20wooden%20shelf%20system%20organic%20curves%20modern%20storage%20furniture%20natural%20wood%20minimalist%20background%20contemporary%20design&width=500&height=600&seq=catalog-3&orientation=portrait',
    description: 'Organik formlar ve akıcı hatlarla tasarlanmış, işlevsel ve estetik depolama çözümü.',
    materials: ['Masif Meşe', 'Metal Bağlantılar', 'Doğal Yağ Kaplama'],
    dimensions: '180cm x 40cm x 200cm'
  },
  {
    id: 4,
    name: 'Rattan Sarkıt Lamba',
    category: 'Aydınlatma',
    image: 'https://readdy.ai/api/search-image?query=handwoven%20rattan%20pendant%20lamp%20natural%20fiber%20lighting%20fixture%20organic%20design%20warm%20ambient%20light%20minimalist%20white%20background%20artisan%20craftsmanship&width=500&height=600&seq=catalog-4&orientation=portrait',
    description: 'El örgüsü rattan ile üretilmiş, doğal ve sürdürülebilir aydınlatma çözümü.',
    materials: ['Doğal Rattan', 'Bambu Lifleri', 'El Örgü'],
    dimensions: '45cm x 45cm x 60cm'
  },
  {
    id: 5,
    name: 'Minimalist Konsol Masa',
    category: 'Masa',
    image: 'https://readdy.ai/api/search-image?query=minimalist%20wooden%20console%20table%20slim%20design%20natural%20oak%20wood%20modern%20entryway%20furniture%20clean%20white%20background%20studio%20photography%20elegant%20simplicity&width=500&height=600&seq=catalog-5&orientation=portrait',
    description: 'İnce ve zarif hatlarıyla dikkat çeken, giriş holü veya oturma odası için ideal konsol masa.',
    materials: ['Meşe Ahşap', 'Metal Ayaklar', 'Mat Vernik'],
    dimensions: '120cm x 35cm x 80cm'
  },
  {
    id: 6,
    name: 'Organik Sehpa',
    category: 'Masa',
    image: 'https://readdy.ai/api/search-image?query=organic%20shaped%20wooden%20coffee%20table%20natural%20curves%20handcrafted%20furniture%20modern%20living%20room%20minimalist%20background%20studio%20shot%20unique%20design&width=500&height=600&seq=catalog-6&orientation=portrait',
    description: 'Doğal formlardan ilham alan, her açıdan farklı bir güzellik sunan organik sehpa.',
    materials: ['Ceviz Ahşap', 'Doğal Form', 'Yağ Kaplama'],
    dimensions: '90cm x 60cm x 40cm'
  },
  {
    id: 7,
    name: 'Ergonomik Çalışma Sandalyesi',
    category: 'Oturma',
    image: 'https://readdy.ai/api/search-image?query=ergonomic%20wooden%20office%20chair%20modern%20design%20natural%20wood%20frame%20comfortable%20seating%20minimalist%20white%20background%20studio%20photography%20contemporary%20furniture&width=500&height=600&seq=catalog-7&orientation=portrait',
    description: 'Uzun çalışma saatleri için tasarlanmış, ergonomik ve şık çalışma sandalyesi.',
    materials: ['Meşe Ahşap', 'Deri Döşeme', 'Ayarlanabilir Mekanizma'],
    dimensions: '60cm x 65cm x 95cm'
  },
  {
    id: 8,
    name: 'Modüler Kitaplık',
    category: 'Depolama',
    image: 'https://readdy.ai/api/search-image?query=modular%20wooden%20bookshelf%20system%20geometric%20design%20natural%20wood%20modern%20storage%20furniture%20clean%20background%20contemporary%20minimalist%20style&width=500&height=600&seq=catalog-8&orientation=portrait',
    description: 'İhtiyacınıza göre şekillendirilebilen, modüler ve esnek kitaplık sistemi.',
    materials: ['Kayın Ahşap', 'Metal Bağlantılar', 'Ayarlanabilir Raflar'],
    dimensions: '160cm x 30cm x 180cm'
  },
  {
    id: 9,
    name: 'Ahşap Yatak Başlığı',
    category: 'Yatak Odası',
    image: 'https://readdy.ai/api/search-image?query=wooden%20bed%20headboard%20natural%20wood%20grain%20modern%20bedroom%20furniture%20minimalist%20design%20clean%20white%20background%20studio%20shot%20elegant%20craftsmanship&width=500&height=600&seq=catalog-9&orientation=portrait',
    description: 'Yatak odanıza doğallık ve sıcaklık katan, masif ahşaptan üretilmiş yatak başlığı.',
    materials: ['Masif Ceviz', 'Doğal Vernik', 'El İşçiliği'],
    dimensions: '180cm x 10cm x 120cm'
  },
  {
    id: 10,
    name: 'Bambu Yan Sehpa',
    category: 'Masa',
    image: 'https://readdy.ai/api/search-image?query=bamboo%20side%20table%20round%20top%20natural%20sustainable%20material%20modern%20minimalist%20furniture%20clean%20white%20background%20studio%20photography%20eco%20friendly%20design&width=500&height=600&seq=catalog-10&orientation=portrait',
    description: 'Sürdürülebilir bambu malzemeden üretilmiş, hafif ve şık yan sehpa.',
    materials: ['Bambu', 'Doğal Kaplama', 'Metal Detaylar'],
    dimensions: '45cm x 45cm x 55cm'
  },
  {
    id: 11,
    name: 'Deri Dinlenme Koltuğu',
    category: 'Oturma',
    image: 'https://readdy.ai/api/search-image?query=leather%20lounge%20chair%20modern%20design%20wooden%20frame%20comfortable%20seating%20minimalist%20background%20studio%20photography%20luxury%20furniture%20elegant%20style&width=500&height=600&seq=catalog-11&orientation=portrait',
    description: 'Konfor ve lüksü bir araya getiren, doğal deri kaplı dinlenme koltuğu.',
    materials: ['Tam Deri', 'Meşe Çerçeve', 'Yüksek Konfor Sünger'],
    dimensions: '80cm x 95cm x 100cm'
  },
  {
    id: 12,
    name: 'Duvar Lambası',
    category: 'Aydınlatma',
    image: 'https://readdy.ai/api/search-image?query=modern%20wall%20lamp%20sconce%20brass%20metal%20natural%20wood%20accent%20minimalist%20design%20warm%20lighting%20clean%20white%20background%20studio%20shot%20contemporary%20fixture&width=500&height=600&seq=catalog-12&orientation=portrait',
    description: 'Ahşap ve metal kombinasyonuyla tasarlanmış, modern duvar lambası.',
    materials: ['Pirinç Metal', 'Ceviz Ahşap', 'LED Işık'],
    dimensions: '25cm x 15cm x 30cm'
  },
  {
    id: 13,
    name: 'Yuvarlak Yemek Masası',
    category: 'Masa',
    image: 'https://readdy.ai/api/search-image?query=round%20wooden%20dining%20table%20natural%20oak%20wood%20modern%20design%20minimalist%20furniture%20clean%20white%20background%20studio%20photography%20elegant%20craftsmanship&width=500&height=600&seq=catalog-13&orientation=portrait',
    description: 'Aile yemekleri için ideal, geniş ve davetkar yuvarlak yemek masası.',
    materials: ['Meşe Ahşap', 'Çapraz Ayak', 'Mat Vernik'],
    dimensions: '140cm çap x 75cm'
  },
  {
    id: 14,
    name: 'Askılık Sistemi',
    category: 'Depolama',
    image: 'https://readdy.ai/api/search-image?query=wooden%20coat%20rack%20wall%20mounted%20hooks%20natural%20wood%20modern%20entryway%20furniture%20minimalist%20design%20clean%20background%20contemporary%20style&width=500&height=600&seq=catalog-14&orientation=portrait',
    description: 'Giriş holü için pratik ve şık, duvara monte askılık sistemi.',
    materials: ['Kayın Ahşap', 'Metal Askılar', 'Doğal Yağ'],
    dimensions: '80cm x 10cm x 15cm'
  },
  {
    id: 15,
    name: 'Ahşap Bank',
    category: 'Oturma',
    image: 'https://readdy.ai/api/search-image?query=wooden%20bench%20natural%20wood%20grain%20modern%20minimalist%20design%20handcrafted%20furniture%20clean%20white%20background%20studio%20photography%20simple%20elegant%20seating&width=500&height=600&seq=catalog-15&orientation=portrait',
    description: 'Sade ve zarif tasarımıyla her mekana uyum sağlayan ahşap bank.',
    materials: ['Masif Meşe', 'Doğal Kenar', 'Yağ Kaplama'],
    dimensions: '150cm x 40cm x 45cm'
  },
  {
    id: 16,
    name: 'Çalışma Masası',
    category: 'Masa',
    image: 'https://readdy.ai/api/search-image?query=modern%20wooden%20desk%20natural%20wood%20top%20metal%20legs%20contemporary%20home%20office%20furniture%20minimalist%20design%20clean%20white%20background%20studio%20photography&width=500&height=600&seq=catalog-16&orientation=portrait',
    description: 'Ev ofisi için tasarlanmış, geniş çalışma yüzeyli modern masa.',
    materials: ['Ceviz Ahşap', 'Çelik Ayaklar', 'Kablo Yönetimi'],
    dimensions: '140cm x 70cm x 75cm'
  },
  {
    id: 17,
    name: 'Ayaklı Ayna',
    category: 'Aksesuar',
    image: 'https://readdy.ai/api/search-image?query=standing%20floor%20mirror%20wooden%20frame%20natural%20oak%20modern%20bedroom%20furniture%20minimalist%20design%20clean%20white%20background%20studio%20photography%20elegant%20style&width=500&height=600&seq=catalog-17&orientation=portrait',
    description: 'Yatak odası veya giyinme odası için zarif ahşap çerçeveli ayaklı ayna.',
    materials: ['Meşe Çerçeve', 'Yüksek Kalite Ayna', 'Ayarlanabilir Açı'],
    dimensions: '60cm x 180cm'
  },
  {
    id: 18,
    name: 'Saksı Standı',
    category: 'Aksesuar',
    image: 'https://readdy.ai/api/search-image?query=wooden%20plant%20stand%20multi%20tier%20natural%20wood%20modern%20indoor%20garden%20furniture%20minimalist%20design%20clean%20white%20background%20studio%20photography%20contemporary%20style&width=500&height=600&seq=catalog-18&orientation=portrait',
    description: 'İç mekan bitkileriniz için çok katlı, şık ahşap saksı standı.',
    materials: ['Bambu', 'Doğal Vernik', 'Hafif Yapı'],
    dimensions: '80cm x 30cm x 100cm'
  },
  {
    id: 19,
    name: 'Tv Ünitesi',
    category: 'Depolama',
    image: 'https://readdy.ai/api/search-image?query=modern%20tv%20stand%20wooden%20cabinet%20natural%20wood%20media%20console%20minimalist%20furniture%20clean%20white%20background%20studio%20photography%20contemporary%20design%20storage&width=500&height=600&seq=catalog-19&orientation=portrait',
    description: 'Geniş depolama alanı ve kablo yönetimi ile modern TV ünitesi.',
    materials: ['Meşe Ahşap', 'Yumuşak Kapanış', 'Açık Raflar'],
    dimensions: '180cm x 45cm x 50cm'
  },
  {
    id: 20,
    name: 'Şezlong',
    category: 'Oturma',
    image: 'https://readdy.ai/api/search-image?query=modern%20chaise%20lounge%20natural%20fabric%20upholstery%20wooden%20legs%20contemporary%20furniture%20minimalist%20design%20clean%20white%20background%20studio%20photography%20elegant%20relaxation&width=500&height=600&seq=catalog-20&orientation=portrait',
    description: 'Dinlenme ve okuma için ideal, konforlu ve şık şezlong.',
    materials: ['Keten Kumaş', 'Ceviz Ayaklar', 'Ergonomik Tasarım'],
    dimensions: '160cm x 70cm x 85cm'
  }
];
